<template>
  <div class="card">
    <div class="card-body">
      <slot name="contents"></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CardOrigin',
}
</script>

<style scoped>
.card {
  margin: 24px 0 24px;
  padding: 0px;
}
.card-body {
  padding: 20px 30px 20px 30px !important;
}
</style>